<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bwy3zr/tc-custom/9781647508777.jpg?1724126147911" alt="This image is the cover for the book Darkness Without Limits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Darkness Without Limits
      </h1>
      <p class="bookDescription body article font2">
        <p><em>Darkness Without Limits</em> is a poetic, haunting and unforgettable novel about a boy’s upbringing in a small rural village from the age of ten until he is twenty. He lives a life in constant fear, of other people, of not having any future and of a darkness inside him that makes his world increasingly unreal. </p><p>After high school, the boy spends a restless summer with a group of outsiders that challenges his worldview and sanity. The novel follows his slow descent into darkness and his attempt to fight the evil inside him. Peter Legård writes with great insight into the world of children and youth and with the feeling that there are no ‘ordinary people’. </p><p>Despite the dark themes, this novel ultimately concerns our shared humanity and that there is always hope.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Legaard Nielsen
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:16px;font-family:"Arial",sans-serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;'>Peter Legaard Nielsen, born in 1960, is a Danish author, who made his debut with a poetry collection, <em>The Bloody Temple of the Heart</em>, in 1985 and had his breakthrough with the novel, <em>While the Sun Slowly Burns Up</em>, in 1987. <em>Darkness Without Limits</em> is his second novel. He has published 9 novels and 2 poetry collections and edited a large number of anthologies.</span></p><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:16px;font-family:"Arial",sans-serif;text-align:justify;'><br></p><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:16px;font-family:"Arial",sans-serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;'>He was chairman of the Danish Fiction Writers Association from 1997&ndash;2001 and from 2002&ndash;2007. In 1992, he was awarded a 3-year grant from the state&rsquo;s Art Fund. He was a literary reviewer at a newspaper from 1987 to 1992.</span></p><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:16px;font-family:"Arial",sans-serif;text-align:justify;'><br></p><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:16px;font-family:"Arial",sans-serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;'>Peter is also an Authorized Advanced Rolfer&trade; and an Authorized Level 3 IFS Practitioner.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08e850a3